module.exports = __webpack_public_path__ + "static/img/confirming.8152eaf9.png";